import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '@cloudscape-design/components/app-layout';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import Container from '@cloudscape-design/components/container';
import Box from '@cloudscape-design/components/box';
import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';

const ThresholdAnalysisPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppLayout
      navigationHide
      toolsHide
      contentType="default"
      content={
        <ContentLayout
          header={
            <Header
              variant="h1"
              description="Evaluate and tune monitor thresholds across your services"
              actions={<Button onClick={() => navigate('/')}>← Back</Button>}
            >
              📊 Monitor Threshold Analysis
            </Header>
          }
        >
          <Container>
            <SpaceBetween size="m">
              <Box variant="h3">Coming soon</Box>
              <Box variant="p" color="text-status-inactive">
                This feature is under development. It will help you identify misconfigured alarm thresholds,
                reduce alert noise, and find gaps in your monitoring coverage.
              </Box>
            </SpaceBetween>
          </Container>
        </ContentLayout>
      }
    />
  );
};

export default ThresholdAnalysisPage;
